export const LEVELS = [
  { title: "Bronze", min: 0, color: "#B87333" },
  { title: "Silver", min: 75, color: "#7C8794" },
  { title: "Gold", min: 250, color: "#D99E02" },
  { title: "Self-Agent", min: 500, color: "#00A8BF" },
];

// Levels are based on LIFETIME coins earned (xp) — spending coins never drops a level.
export function levelOf(xp) {
  let idx = 0;
  LEVELS.forEach((l, i) => { if (xp >= l.min) idx = i; });
  const cur = LEVELS[idx];
  const next = LEVELS[idx + 1] || null;
  const pct = next ? Math.min(100, Math.floor(((xp - cur.min) / (next.min - cur.min)) * 100)) : 100;
  return { idx, title: cur.title, color: cur.color, min: cur.min, next, pct };
}
